import React from "react";
import { Checkbox, FormGroup, FormControlLabel } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { FormContainer } from "components/ui/FormField/FormFieldContainer";
import Page from "components/ui/Page/Page";

/**
 * @description This component renders the "Care Pathway Treat" step of the enrollment process. It presents a list of options to the user, allowing them to select any that apply to them.
 * @param {Array} options - The list of options to display to the user.
 * @param {Array} selected - The list of currently selected options.
 * @param {function} onChange - A function to handle changes to the selected options.
 * @param {function} onSubmit - A function to handle the submission of the form.
 * @param {boolean} isSubmitting - A boolean indicating whether the form is currently being submitted.
 * @returns {JSX.Element} The rendered component.
 */
const CarePathwayTreat = ({
    options = [],
    selected,
    onChange,
    onSubmit,
    isSubmitting,
}) => {
    const handleChange = (optionValue) => {
        let newChecked = [];
        // If 'None of the above' is selected, uncheck all other options
        if (optionValue === "NONE" && !selected.includes(optionValue)) {
            newChecked = ["NONE"];
        }
        // Else handle other options
        else {
            newChecked = selected.includes(optionValue)
                ? selected.filter((value) => value !== optionValue)
                : [...selected, optionValue];
        }
        // set form state on change
        onChange("treat", "treatOptions", newChecked, "checkbox");
    };

    return (
        <Page
            heading="Care Pathway"
            subHeading="This information will help us personalize your care pathway."
        >
            <FormContainer
                heading="Do any of the following apply to you?"
                subHeading="Select all that apply."
                sx={{
                    width: "65%",
                }}
            >
                <FormGroup>
                    {options.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            control={
                                <Checkbox
                                    // Disable all other options if 'None of the above' is selected
                                    disabled={
                                        selected.includes("NONE") && option.value !== "NONE"
                                    }
                                    checked={selected.includes(option.value)}
                                    onChange={() => handleChange(option.value)}
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </FormGroup>
                <LoadingButton
                    variant="contained"
                    onClick={onSubmit}
                    sx={{ mt: 3 }}
                    disabled={!selected.length}
                    loading={isSubmitting}
                >
                    NEXT
                </LoadingButton>
            </FormContainer>
        </Page>
    );
};

export default CarePathwayTreat;
